import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderWpForm = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();



const [tblagencyreg, setTblagencyreg] = useState([]);
const [tblwrkpmtimgssent, setTblwrkpmtimgssent] = useState([]);
const [tblwptappudakimport, setTblwptappudakimport] = useState([]);


const [officeopts, setOfficeopts] = useState([]);
const [usergrpoptions, setUsergrpoptions] = useState([]);


const [wptusername, setWptusername] = useState({});
const [sessionvaropts, setSessionvaropts] = useState([]);

const [dowait, setDowait] = useState({on:false});

const [searchcrit, setSearchcrit] = useState({
	txt:''
	, usergroup:''
	, custype:''
	, userlocation: ''
	});
	
const [crit, setCrit] = useState({
	DATE1: formatDate(new Date())
	, YRMM1: formatDate(subtractMonth(new Date(), 4)).substring(0,7)
	, YRMM2: formatDate(new Date()).substring(0,7)
	});



const location = useLocation();


useEffect(() => {

const USERNAME = sessionStorage.getItem("USERNAME")??"";

if (USERNAME!="ajones"){
	navigate("/");
	return;
	}//end if

document.title =   "Receipts added";



if (tblwptappudakimport.length<1){
	rptwptappudakimport();
	}//end if


/*
if (tblagencyreg.length<1){
	gettblagencyreg();
	}//end if

*/
	
 },[]);

useEffect(() => {
	//document.getElementsByName('txt')[0].focus();
	
 },[JSON.stringify(tblagencyreg)]);

useEffect(() => {

	console.log('wptusername.USERNAME: '+wptusername.USERNAME);//JSON.stringify(webuser)
	if (wptusername.USERNAME!=undefined){
		if (modal.open==false){
			toggleModalsm();
			
			}//end if
			
			
		}//end if
	
 },[wptusername]);

useEffect(() => {
		//gettblagencyreg();
 },[searchcrit]);

function searchcritChange(e){
	
	const {name, value}=e.target;
console.log("searchcritChange name: "+name+' '+value);

	setSearchcrit((prev)=>{
		return {...prev, [name]:value}	
	});
	
	//setSearchcrit({name:e.target.name, txt:e.target.value});
}//end if


async function gettblwrkpmtimgssent(){


console.log("rptwptappudakimport: "+JSON.stringify(crit));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( crit )
  };		
setTblwrkpmtimgssent([]);
  await fetch(resturl+'rarwpform/tblwrkpmtimgssent',requestOptions)
      .then(res => res.json())
      .then(res => 	afterrtblwrkpmtimgssent(res) )
      .catch(err => console.log(err));

}//end func

function afterrtblwrkpmtimgssent(res){
	
	if (!res.length)
		return;
	
let htmrows=[];
let rowcount=1;
res.map((col, index) => {
	
	const trkey='tr_'+index;
	const htmrow=<tr key={trkey} >
				<td align="right" >{rowcount}&nbsp;</td>
				<td align="left" >{col['SUBMITTED_TO_CSC']}</td>
				<td align="left" >{col['REF_NUM']}</td>
				<td align="left" >{col['MPE_PASSPORT_NBR']}</td>
				<td align="left" >{col['MPE_NAME']}</td>
				<td align="left" >{col['MPR_NAME']}</td>
				<td align="left" >{col['WORK_PERMIT_ID']}</td>
				<td align="left" >{col['PHOTO_FILE_SIZE']}</td>
				<td align="left" >{col['THUMB_FILE_SIZE']}</td>
				<td align="left" >{col['IMGS_SENT_PREM']}</td>
				</tr>;
	htmrows.push(htmrow);
	rowcount++;
	});//end map	
	
setTblwrkpmtimgssent(htmrows);	
	
}//end func









async function rptwptappudakimport(){


console.log("rptwptappudakimport: "+JSON.stringify(crit));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( crit )
  };		
setTblwptappudakimport([]);
  await fetch(resturl+'rarwpform/rptwptappudakimport',requestOptions)
      .then(res => res.json())
      .then(res => 	afterrptwptappudakimport(res) )
      .catch(err => console.log(err));

}//end func

function afterrptwptappudakimport(res){
	
	gettblwrkpmtimgssent();
	
	if (!res.length)
		return;
	
let htmrows=[];
let rowcount=1;
res.map((col, index) => {
	
	const trkey='tr_'+index;
	const htmrow=<tr key={trkey} >
				<td align="right" >{rowcount}&nbsp;</td>
				<td align="left" >{col['DOC_DATE']}</td>
				<td align="left" >{col['DOC_NO']}</td>
				<td align="left" >{col['DOC_AMT']}</td>
				<td align="left" >{col['DOC_COMMENT']}</td>
				<td align="left" >{col['MODIFY_DATE']}</td>
				<td align="left" >{col['IMPORT_DATE']}</td>
				<td align="left" >{col['UDAK_NO']}</td>
				<td align="left" >{col['ACCOUNT']}</td>
				<td align="left" >{col['VCHR_TYPE']}</td>
				<td align="left" >{col['DATE_PAID']}</td>
				<td align="left" >{col['REF_NUM']}</td>
				<td align="left" >{col['MPE_PASSPORT_NBR']}</td>
				<td align="left" >{col['MPE_NAME']}</td>
				<td align="left" >{col['MPR_NAME']}</td>
				<td align="left" >{col['SUBMITTED_TO_CSC']}</td>
				</tr>;
	htmrows.push(htmrow);
	rowcount++;
	});//end map	
	
setTblwptappudakimport(htmrows);	
	
}//end func

async function gettblagencyreg(){

/*
const crit=searchcrit.name=='custype'?'':searchcrit.txt.trim();
const custype=searchcrit.name=='custype'?searchcrit.txt.trim():'';
const userlocation=searchcrit.name=='userlocation'?searchcrit.txt.trim():'';
USER_GRP_ID
*/
let params = searchcrit;
params.USERNAME=sessionStorage.getItem("USERNAME");


console.log("gettblagencyreg: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setTblagencyreg([]);
  await fetch(resturl+'rarwpform/gettblagencyreg',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblagencyreg(res) )
      .catch(err => console.log(err));

}//end func


function aftergettblagencyreg(res){
	
if (!res.length)
	return;
	
console.log('aftergettblagencyreg, res.length: '+res.length);

let htmrows=[];
let AGENCYREG_ID=null;
let agc_person=[];
let ARR_AGENCYREG_ID=[];
let rowcount=1;
let agency_index=0;

res.map((col, index) => {
	
	const BAND=col['BAND'];
	if (BAND.startsWith("01")){
		const trkey='tr_'+index;
		agc_person.push([]);
		ARR_AGENCYREG_ID.push(col['AGENCYREG_ID']);
		
		const htmrow=<tr key={trkey} valign="top" >
		<td align='right' >{rowcount}</td>
		<td align='left' >{col['BUSINESSNAME']}</td>
		<td align='left' >{col['EMAIL']}</td>
		<td align='left' >{col['PHONE']}</td>
		<td align='left' >
							<table align="center" width="100%" >
							<tr>
							<th>Person Type</th>
							<th>Person Name</th>
							<th>Status Card #</th>
							</tr>
							<tbody>{agc_person[index]}</tbody>
							</table>
		</td>
		<td align='left' >{col['LOCATION']}</td>
		<td align='left' >{col['LICENSETYPE']}</td>
		</tr>;
		htmrows.push(htmrow);			
		rowcount++;
		}//end if
	else if (BAND.startsWith("02")){
		
		for (var i=0; i<ARR_AGENCYREG_ID.length; i++){
			if (ARR_AGENCYREG_ID[i]==col['AGENCYREG_ID'])
			agc_person[i].push(<tr>
						<td align='left' >{col['OWNER_OR_EMPLOYEE']}</td>
						<td align='left' >{col['PERSON']}</td>
						<td align='left' >{col['STATUSCARDNO']}</td>
						</tr>
						);
			}//end for
		
		
/*
		if (AGENCYREG_ID==null)
			AGENCYREG_ID=col['AGENCYREG_ID'];
		
		if (col['AGENCYREG_ID']!=AGENCYREG_ID)
			agency_index++;
			
		if (agency_index<agc_person.length)

*/

		}//end else
		


	});//end map


setTblagencyreg(htmrows);
}//end func


function getwptuser(e, USERNAME){

e.preventDefault();

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:USERNAME} )
  };		

  fetch(resturl+'rarwpform/getwptuser',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptuser(res) )
      .catch(err => console.log(err));

}//end func







async function updatewptusername(){

const params={
USERNAME : sessionStorage.getItem("USERNAME")
, wptuser : wptusername
	
}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
//USER_GRP_ID
  await fetch(resturl+'rarwpform/updatewptusername',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatewptusername(res) )
      .catch(err => console.log(err));

}//end func


function afterupdatewptusername(res){
	if (!res.length){
		showsnackbar('something went wrong, please try again');
		return;
		}
		
		showsnackbar('changes were saved successfully');
		
		setWptusername((prev)=>{
			return {...prev
				, TAX_CENTRE_DESC:res[0].TAX_CENTRE_DESC??""}
				});
			
	
		
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

function aftergetwptuser(res){
if (res.length==undefined)
	return;

let datas={MD:""};

for(var attributename in res[0]){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
	}//end for	
	
console.log("USER_GRP_ID: "+datas.USER_GRP_ID);
console.log("IRD_LOGIN_ID: "+datas.IRD_LOGIN_ID);
setWptusername(datas);

}//end func

function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;

const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func


function aftergettblagencyregOld(res){
	
if (!res.length)
	return;
	
console.log('aftergettblagencyreg, res.length: '+res.length);

let htmrows=[];
let AGENCYREG_ID=null;
let agc_person=[];
let rowcount=1;

res.map((col, index) => {
	
	if (AGENCYREG_ID==null)
		AGENCYREG_ID=col['AGENCYREG_ID'];
	
	if (col['AGENCYREG_ID']==AGENCYREG_ID){
		AGENCYREG_ID=col['AGENCYREG_ID'];
		agc_person.push(<tr>
					<td align='left' >{col['OWNER_OR_EMPLOYEE']}</td>
					<td align='left' >{col['PERSON']}</td>
					<td align='left' >{col['STATUSCARDNO']}</td>
					</tr>
					);
		}//end if
else	{
		console.log("agc_person.length: "+agc_person.length);
		const trkey='tr_'+index;
		
		const htmrow=<tr key={trkey} valign="top" >
		<td align='right' >{rowcount}</td>
		<td align='left' >{col['BUSINESSNAME']}</td>
		<td align='left' >{col['EMAIL']}</td>
		<td align='left' >{col['PHONE']}</td>
		<td align='left' >
							<table align="center" width="100%" >
							<tr>
							<th>Person Type</th>
							<th>Person Name</th>
							<th>Status Card #</th>
							</tr>
							<tbody>{agc_person}</tbody>
							</table>
		</td>
		<td align='left' >{col['LOCATION']}</td>
		<td align='left' >{col['LICENSETYPE']}</td>
		</tr>;
		htmrows.push(htmrow);	

		agc_person=[];
		AGENCYREG_ID=col['AGENCYREG_ID'];
		rowcount++;

	}//end else

		
		
		
	
//	AGENCY_ID <td align='left' ><a href="#" className="nodecor" onClick={(e)=>{getwptuser(e, USERNAME);}}><img src="img/folderyel.png"  height='18'  border="0" /> {col['FULLNAME']}</a></td>
	

	});//end map

const col = res[res.length-1];
const trkey='tr_00x';
		
		const htmrow=<tr key={trkey} valign="top" >
		<td align='right' >{rowcount}</td>
		<td align='left' >{col['BUSINESSNAME']}</td>
		<td align='left' >{col['EMAIL']}</td>
		<td align='left' >{col['PHONE']}</td>
		<td align='left' >
							<table align="center" width="100%" >
							<tr>
							<th>Person Type</th>
							<th>Person Name</th>
							<th>Status Card #</th>
							</tr>
							<tbody>{agc_person}</tbody>
							</table>
		</td>
		<td align='left' >{col['LOCATION']}</td>
		<td align='left' >{col['LICENSETYPE']}</td>
		</tr>;
		htmrows.push(htmrow);

setTblagencyreg(htmrows);
}//end func


function wptuserroles(e, username){
e.preventDefault();
window.alert("This feature not ready yet");	
}//end func



function formatDate(pDate){
	//const d = new Date();
var yyyy = pDate.getFullYear();
var dd = ("0" + pDate.getDate()).slice(-2);
var mm = ("0" + (pDate.getMonth() + 1)).slice(-2);
const resDate = `${yyyy}-${mm}-${dd}`;
console.log("resDate: "+resDate);
return resDate;

}

function subtractMonth(date, months) {
  let d = date.getDate();
  date.setMonth(date.getMonth() - months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}//end func 





function handleChange(e){
	
	
	
	const {name, value}=e.target;

setCrit((prev)=>{
	return {...prev, [name]:value}
	});


}//end func


  return (
    <>
	
	
<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Receipts added to Applications</p>	

<table align='center' style={{width:"25%"}} >
<tbody>
<tr>
	<td align="right" >Start Year & Month:</td>
	<td align="left" ><input name="YRMM1" value={crit.YRMM1} size="9" onChange={(e)=>{handleChange(e);}} /></td>
</tr>
<tr>
	<td align="right" >End Year & Month:</td>
	<td align="left" ><input name="YRMM2" value={crit.YRMM2} size="9" onChange={(e)=>{handleChange(e);}} /></td>
</tr>
<tr>
	<td align="right" ></td>
	<td align="left" ><button className="button" onClick={(e)=>{rptwptappudakimport();}} >submit dates</button></td>
</tr>
</tbody>
</table>


<table align='center' className='customers' style={{width:"90%"}} >
<thead>
<tr>	
<th align="left" >#</th>
<th align="left" >DOC_DATE</th>
<th align="left" >DOC_NO</th>
<th align="left" >DOC_AMT</th>
<th align="left" >DOC_COMMENT</th>
<th align="left" >MODIFY_DATE</th>
<th align="left" >IMPORT_DATE</th>
<th align="left" >UDAK_NO</th>
<th align="left" >ACCOUNT</th>
<th align="left" >VCHR_TYPE</th>
<th align="left" >DATE_PAID</th>
<th align="left" >REF_NUM</th>
<th align="left" >MPE_PASSPORT_NBR</th>
<th align="left" >MPE_NAME</th>
<th align="left" >MPR_NAME</th>
<th align="left" >SUBMITTED_TO_CSC</th>	
</tr>
</thead>	
<tbody>
	{tblwptappudakimport}
</tbody>
</table>
	
	
	
	
	
	
	
<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Applications Images Sent Prem</p>	

<table align='center' style={{width:"25%"}} >
<tbody>
<tr>
	<td align="right" >Date:</td>
	<td align="left" ><input name="DATE1" value={crit.DATE1} size="9" onChange={(e)=>{handleChange(e);}} /></td>
</tr>
<tr>
	<td align="right" ></td>
	<td align="left" ><button className="button" onClick={(e)=>{gettblwrkpmtimgssent();}} >submit date</button></td>
</tr>
</tbody>
</table>


<table align='center' className='customers' style={{width:"90%"}} >
<thead>
<tr>	
<th align="left" >#</th>
<th align="left" >SUBMITTED_TO_CSC</th>	
<th align="left" >REF_NUM</th>
<th align="left" >MPE_PASSPORT_NBR</th>
<th align="left" >MPE_NAME</th>
<th align="left" >MPR_NAME</th>
<th align="left" >WORK PMT ID</th>
<th align="left" >PHOTO</th>
<th align="left" >THUMB</th>
<th align="left" >DATE SENT</th>
</tr>
</thead>	
<tbody>
	{tblwrkpmtimgssent}
	
</tbody>
</table>	
	
	
	{/*
	<table align='center' className='customers' style={{width:"90%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>Business Name</th>
		<th>Email</th>
		<th>Telephone</th>
		<th>&nbsp;</th>
		<th>Location</th>
		<th>License Type</th>

	</tr>
	</thead>
	<tbody>
		{tblagencyreg}
	</tbody>
	</table>

*/}


<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
			<table align='center'>
			<tbody>

			</tbody>
			</table>
			
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;